function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "6.490623mm",
    height: "10.643287mm",
    viewBox: "0 0 6.490623 10.643287",
    id: "svg5",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-35.610666,-38.720313)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(7.1093694,17.773424)"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 1,
      strokeLinecap: "round",
      strokeLinejoin: "round"
    },
    d: "m 29.001297,28.303169 c 0,1.539222 1.229118,2.787007 2.745312,2.787007 1.516193,0 2.745311,-1.247785 2.745311,-2.787007 0,-1.539222 -1.229118,-2.787008 -2.745311,-2.787008 v -4.069272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.b43792b2afcd5f66104888c84a4276db.svg";
export { ForwardRef as ReactComponent };